<template>
  <div class="speakers-table">
    <table class="pure-table pure-table-striped">
      <thead role="rowgroup" >
        <tr role="row">
          <th role="cell">Name</th>
          <th role="cell" v-if="!combineDelegateDistrict">District</th>
          <th role="cell" v-if="showOpinion">Opinion</th>
          <th role="cell" v-if="showState">Status</th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr
          v-for="(speaker,i) in speakers"
          :key="`speaker-${i}`"
          :class="{'speaker-active' : showState && speaker.status === 'Active'}"
        >
          <td v-if="!combineDelegateDistrict">{{speaker.delegate.getName()}}</td>
          <td v-else>{{combine(speaker)}}</td>
          <td v-if="!combineDelegateDistrict">{{speaker.delegate.associationName}}</td>
          <td v-if="showOpinion">
            <opinion-view :opinion="speaker.opinion"/>
          </td>
          <td v-if="showState">
            <div class="p-d-flex p-ai-center">
              <span v-if="speaker.isActive()">
                <span class="blob green"/>
              </span>
              <speaker-state-display :state="speaker.status"/>
            </div>
          </td>
        </tr>
        <tr v-if="!speakers.length">
          <td :colspan="showState ? 3 : 2" class="empty-state">n/a</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable'
import SpeakerStateDisplay from './SpeakerStateDisplay.vue'
import OpinionView from '../motions/OpinionView.vue'
export default {
  name: 'SpeakersTable',
  components: {
    DataTable,
    SpeakerStateDisplay,
    OpinionView
  },
  props: {
    speakers: {
      type: Array,
      required: true
    },
    showState: {
      type: Boolean,
      default: false
    },
    showOpinion: {
      type: Boolean,
      default: false
    },
    combineDelegateDistrict: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    combine (speaker) {
      const parts = [speaker.delegate.getName(), speaker.delegate.associationName]
      return parts.filter((str) => str !== null && str.trim() !== '').join(', ')
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
}
tr.speaker-active td {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakersTable.vue